<template>
  <div>
    <dialogQRCode v-if="show !== null" ref="dialogQRCode" :textOfQRCode="textOfQRCode" :show.sync="show" />
  </div>
</template>

<script>
import { bindNewBind } from '@/api/data'
import dialogQRCode from '@/components/pickupQRCodeNew/dialogQRCode'
export default {
  name: 'PickupQRCode',
  components: {
    dialogQRCode
  },
  props: {

  },
  data() {
    return {
      show: null,
      textOfQRCode: '',
      qrcodeId: ''
    }
  },
  mounted() {
    $bus.$on('whatsAppSocket-waLoginInfo', this.watchLoginInfo)
  },
  methods: {
    watchLoginInfo(data = { status: 1 }) {
      // id正确 走流程
      if (this.qrcodeId === data.uid) {
        // 换起
        if (data.status === 1) {
          this.textOfQRCode = data.detail
          this.$refs.dialogQRCode && this.$refs.dialogQRCode.createQECode(data.detail)
        }
        // 扫码成功
        if (data.status === 2) {
          this.show = null
          console.log('扫码成功')
          // TODO 清id
          this.$emit('success')
        }
      }
    },
    closeQRcode() {
      this.show = null
      this.$refs.dialogQRCode && this.$refs.dialogQRCode.closeLoading()
    },
    runAwait(message) {
      this.closeQRcode()
      this.$message.warning(message)
    },
    // 换起弹窗  传uid表示替换逻辑 否则是新增  （增加phoneType:1 营销号,2绑定号）
    async bindNewBind(phoneType, uid) {
      this.show = true
      const startTime = new Date().getTime()
      const { err, data, code, message } = await bindNewBind({ phoneType, uid })
      if (code && code === 200) {
        this.qrcodeId = data
      }
      if (code && code === 511) {
        const endTime = new Date().getTime()
        if (endTime - startTime < 2000) {
          setTimeout(() => this.runAwait(message), 1500)
        } else {
          this.runAwait(message)
        }
      }
      if (err) {
        this.closeQRcode()
      }
    }

  },
  beforeDestroy() {
    $bus.$off('whatsAppSocket-waLoginInfo', this.watchLoginInfo)
  }
}
</script>

<style scoped lang="scss">
</style>
